import { Component, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { StatusComponent } from 'src/app/shared/components/status/status.component';

import { ModalSelectUserConfig } from 'src/app/shared/components/modal-select-user/shared';
import { SessionService } from 'src/app/shared/services';
import { capitalize, ResponsePagination } from 'src/app/shared/utils';

@Component({
  selector: 'app-modal-select-user',
  templateUrl: './modal-select-user.component.html',
  styleUrls: ['./modal-select-user.component.sass']
})
export class ModalSelectUserComponent {
  @ViewChild('status') status: StatusComponent;

  private resolve: any;
  private reject: any;

  public config: ModalSelectUserConfig;
  public users: { selected: boolean, id: number, name: string, email: string }[] = [];

  constructor(
    private sessionService: SessionService,
    public bsModalRef: BsModalRef,
    public http: HttpClient
  ) { }

  private getUserDescription(userData) {
    const name = `${userData.first_name} ${userData.last_name}`;
    if (name.trim() === '') {
      return userData.email;
    }
    return capitalize(name);
  }

  public setOption(resolve: any, reject: any, config: ModalSelectUserConfig) {
    this.resolve = resolve;
    this.reject = reject;
    this.config = config;

    const ignore = config.ignoreIds || [];
    const unitHash = config.unitHash || this.sessionService.data.unit.hash;
    this.status.setStatus({ info: 'Carregando usuários.', load: true });

    const params = { params: { 'units__hash': unitHash, 'limit': '100', is_active: 'true' } };

    this.http.get<ResponsePagination<any>>('/api/accounts/user/', params).pipe(
      map(res => res.results || [])
    ).subscribe(users => {
      this.users = users
        .filter(user => user.is_active && !ignore.includes(user.id))
        .map(data => ({ id: data.id, name: this.getUserDescription(data), selected: false, email: data.email }))
        .sort((a, b) => a.name.localeCompare(b.name));

      if (this.users.length === 0) {
        this.status.setStatus({ warning: 'Nenhum usuário disponivel!' });
      } else {
        this.status.hide();
      }
    });
  }

  public unselectOthers(itemId: number): void {
    if (this.config.selectOne) {
      this.users.forEach(user => {
        if (user.id != itemId) {
          user.selected = false;
        }
      })
    }
  }

  public ok(_event) {
    const list = this.users
      .filter(user => user.selected)
      .map(user => ({ id: user.id, name: user.name, email: user.email }));

    this.resolve(list);
    this.reject = null;
    this.bsModalRef.hide();
  }

  public onHidden() {
    if (this.reject) {
      this.reject(false);
    }
  }
}
